// 收起-展开
export const TOGGLE_DRAWER = 'toggle_drawer';
// 设置列表
export const SET_SELECTEDLIST = 'set_selectedlist';
// 创建-销毁
export const INITIAL_DRAWER = 'initial_drawer';
// 销毁抽屉
export const DESTORY_DRAWER = 'destory_drawer';

// detail 详情面板
export const DRAWER_DETAIL = 'drawer_detail';
export const SET_COSPACE_SELECTED = 'set_cospace_selected';
// 更新TOTAL
export const SET_TOTAL = 'set_total';
// 初始化抽屉
export const SET_DRAWERS = 'set_drawers';
// 设置抽屉的文件选择器配置
export const SET_DRAWERS_FILE_INDICATOR = 'set_drawers_file_indicator';
// 设置抽屉中文件选择器选中的文件
export const SET_DRAWERS_FILE_INDICATOR_SELECTED = 'set_drawers_file_indicator_selected';
// 抽屉中选择了某一个tab
export const DRAWER_SELECTED_TAB = 'drawer_selected_tab';

export const SET_SPACEID = 'set_spaceId';
// 设置 space 对应的企业 id
export const SET_SPACE_ORGID = 'set_space_orgid';
